import React from 'react';
import ChannelDetailPage from './ChannelDetailPage';

const ChannelsTcgplayerPage: React.FC = () => {
  return <ChannelDetailPage channelName="tcgplayer" />;
};

export default ChannelsTcgplayerPage;
